/**
 * Workspace metrics for the pay-rules Setup tab (commission / bonus pickers).
 * Mirrors Homepage's moneyMetrics builder — bonus-progress does not ship a
 * metrics list; it only returns details for grouping fields on referenced KPIs.
 */
export const moneyMetricsForWorkspace = (workspaceId, companyKpis, details = {}) => {
  const rows = (companyKpis && companyKpis[String(workspaceId)]) || [];
  const seen = new Set();
  return rows
    .filter((k) => {
      if (!k || !(k.title || k.name) || k.disabled) return false;
      const id = String(k._id);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    })
    .map((k) => {
      const id = String(k._id);
      const detail = details[id] || details[k._id] || null;
      const kind = k.kind === "$" || k.kind === "%" ? k.kind : "#";
      return {
        id,
        label: (k.title || k.name || "").trim(),
        kind,
        detail: detail ? detail.field : null,
        values: detail ? detail.values : null,
      };
    });
};
